import { computed } from "vue";
import { useRoute } from "vue-router";
import {
  titleForRoute,
  showWelcomeForRoute,
  showCrumbsForRoute,
} from "@app/config/page-meta";

export function usePageMeta() {
  const route = useRoute();

  const title = computed(() => titleForRoute(route));
  const showWelcome = computed(() => showWelcomeForRoute(route));
  const showCrumbs = computed(() => showCrumbsForRoute(route));

  return { title, showWelcome, showCrumbs };
}
